import { render, staticRenderFns } from "./IndexContent1.vue?vue&type=template&id=e2c45d54&scoped=true"
import script from "./IndexContent1.vue?vue&type=script&lang=js"
export * from "./IndexContent1.vue?vue&type=script&lang=js"
import style0 from "./IndexContent1.vue?vue&type=style&index=0&id=e2c45d54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c45d54",
  null
  
)

export default component.exports